module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/bea30670b5389fa63b25c4fb2292955b.png";